// Feather & Flint — Theme JS

function switchTab(type, btn) {
  document.querySelectorAll('.tab').forEach(function(t) { t.classList.remove('active'); });
  document.querySelectorAll('.mpanel').forEach(function(p) { p.classList.remove('active'); });
  btn.classList.add('active');
  document.getElementById('panel-' + type).classList.add('active');
}

function selectSize(btn, priceId) {
  var group = btn.closest('.size-opts');
  group.querySelectorAll('.sz-btn').forEach(function(b) { b.classList.remove('active'); });
  btn.classList.add('active');
  var size = btn.textContent.trim();
  var priceEl = document.getElementById(priceId);
  var oldEl = document.getElementById(priceId.replace('price', 'old'));
  if (priceEl && priceEl.dataset.prices) {
    var prices = JSON.parse(priceEl.dataset.prices);
    var olds = JSON.parse(priceEl.dataset.old);
    if (prices[size]) {
      priceEl.textContent = '$' + prices[size].toLocaleString();
      if (oldEl && olds[size]) oldEl.textContent = '$' + olds[size].toLocaleString();
    }
  }
}

function addToCart(btn) {
  var orig = btn.textContent;
  btn.textContent = '✓ Added to Cart!';
  btn.style.background = '#5a8c6a';
  setTimeout(function() { btn.textContent = orig; btn.style.background = ''; }, 1800);
}

function toggleFaq(el) { el.classList.toggle('open'); }

function openModal(id) {
  document.getElementById(id).classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeModal(id) {
  document.getElementById(id).classList.remove('open');
  document.body.style.overflow = '';
}

function submitContact(e) {
  e.preventDefault();
  var form = e.target.closest('.contact-form');
  var success = document.getElementById('contact-success');
  if (form) form.style.display = 'none';
  if (success) success.style.display = 'block';
}

/* Tech modal — show/hide slides, no carousel, no overflow clipping */
var techCurrent = 0;

function techSlide(dir) {
  var total = document.querySelectorAll('.tech-slide-wrap').length;
  techCurrent = (techCurrent + dir + total) % total;
  techGoTo(techCurrent);
}

function techGoTo(idx) {
  techCurrent = idx;
  document.querySelectorAll('.tech-slide-wrap').forEach(function(s, i) {
    s.classList.toggle('active', i === idx);
  });
  document.querySelectorAll('.tech-tab-pill').forEach(function(t, i) {
    t.classList.toggle('active', i === idx);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  /* Close modals on overlay click */
  document.querySelectorAll('.modal-overlay').forEach(function(el) {
    el.addEventListener('click', function(e) {
      if (e.target === this) closeModal(this.id);
    });
  });
  /* Close on ESC */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.modal-overlay.open').forEach(function(m) {
        closeModal(m.id);
      });
    }
  });
});

// ═══ TECH MODAL — visibility switch (no scroll, no transform) ═══
var techCurrent = 0;

function techSlide(dir) {
  var wraps = document.querySelectorAll('.tech-slide-wrap');
  var total = wraps.length;
  techCurrent = (techCurrent + dir + total) % total;
  techGoTo(techCurrent);
}

function techGoTo(idx) {
  techCurrent = idx;
  var wraps = document.querySelectorAll('.tech-slide-wrap');
  var pills = document.querySelectorAll('.tech-tab-pill');
  wraps.forEach(function(s, i) {
    if (i === idx) {
      s.classList.add('active');
    } else {
      s.classList.remove('active');
    }
  });
  pills.forEach(function(t, i) {
    if (i === idx) {
      t.classList.add('active');
    } else {
      t.classList.remove('active');
    }
  });
}
